<app-loader-spinner></app-loader-spinner>
<router-outlet *ngIf="!isLoggedIn"></router-outlet>
<div *ngIf="isLoggedIn">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #leftSidenav mode="{{navMode}}" opened fixedInViewport="false" class="mat-elevation-z24">
      <app-left-menu [sidenav]="leftSidenav" [user]="user" [organizations]="organizations" [mainOrganization]="mainOrganization"></app-left-menu>
    </mat-sidenav>
    <mat-sidenav-content
      [@onMainContentChange]="onSideNavChange ? (navMode === 'side' ? 'open':'mobile'): (navMode === 'side' ? 'close':'mobile')">
      <div class="content">
        <app-header [sidenav]="leftSidenav" class="header"></app-header>
        <div class="container">
          <app-filters></app-filters>
          <div class="application-content" [class.mobile]="isMobile">
            <div class="action-header">
              <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
              <span fxFlex></span>
              <a mat-flat-button [color]="buttonAction.color" [routerLink]="buttonAction.action" *ngIf="buttonAction && buttonAction.type === 'LINK'">{{ buttonAction.name | translate }}</a>
              <button mat-flat-button [color]="buttonAction.color" *ngIf="buttonAction && buttonAction.type === 'BUTTON'" (click)="makeAction()">{{ buttonAction.name | translate }}</button>
            </div>
            <div #mainContainer class="card-container" [class.mobile]="isMobile">
              <router-outlet class="mat-elevation-z22" (activate)="onActivate($event)"></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
